import React, { FC } from 'react';
import ModalConfirm from '../../../../../../ModalConfirm';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../theme';

export interface Props {
	isOpen: boolean;
	onClose: () => void;
	onCancel?: () => void;
	onConfirm?: () => void;
}

const PassengersBlockedModal: FC<Props> = ({ isOpen, onClose, onCancel, onConfirm }) => {
	const { t } = useTranslation('SearchForm');
	const { PassengersBlockedModal: theme } = useTheme('SearchForm');

	return (
		<ModalConfirm
			classes={theme}
			isOpen={isOpen}
			onClose={onClose}
			onConfirm={onConfirm}
			onCancel={onCancel}
			title={t('Restrictions')}
			confirmBtn={t('Continue')}
			cancelBtn={t('Cancel')}
		>
			<div className={theme.contentWrapper}>
				{t('When using miles, bookings for some categories will not be available')}
			</div>
		</ModalConfirm>
	);
};

export default PassengersBlockedModal;
